import { History } from "history";

import {
  GET_GRADE_SELECT_LIST_BY_COURSE,
  GET_GRADE_SELECT_LIST_BY_COURSE_ERROR,
  GET_GRADE_SELECT_LIST_BY_COURSE_SUCCESS,
  GetGradeSelectListByCourseAction,
  GetGradeSelectListByCourseErrorAction,
  GetGradeSelectListByCourseSuccessAction,
  ADD_GRADE,
  ADD_GRADE_ERROR,
  ADD_GRADE_SUCCESS,
  AddGradeAction,
  AddGradeErrorAction,
  AddGradeSuccessAction,
  DELETE_GRADE,
  DELETE_GRADE_CONSENT,
  DELETE_GRADE_ERROR,
  DELETE_GRADE_SUCCESS,
  DeleteGradeAction,
  DeleteGradeConsentAction,
  DeleteGradeErrorAction,
  DeleteGradeSuccessAction,
  GET_GRADE,
  GET_GRADES,
  GET_GRADES_ERROR,
  GET_GRADES_SUCCESS,
  GET_GRADE_ERROR,
  GetGradeAction,
  GetGradeErrorAction,
  GetGradeSuccessAction,
  GetGradesAction,
  GetGradesErrorAction,
  GetGradesSuccessAction,
  UPDATE_GRADE,
  UPDATE_GRADE_ERROR,
  UPDATE_GRADE_SUCCESS,
  UpdateGradeAction,
  UpdateGradeErrorAction,
  UpdateGradeSuccessAction,
  GET_GRADE_SUCCESS,
  GET_GRADES_DETAIL_BY_COURSE,
  GET_GRADES_DETAIL_BY_COURSE_ERROR,
  GET_GRADES_DETAIL_BY_COURSE_SUCCESS,
  GetGradesDetailByCourseAction,
  GetGradesDetailByCourseErrorAction,
  GetGradesDetailByCourseSuccessAction,
  GetGradeSelectListByCourseLocalSuccessAction,
  GET_GRADE_SELECT_LIST_BY_COURSE_LOCAL,
  GET_GRADE_SELECT_LIST_BY_COURSE_LOCAL_ERROR,
  GET_GRADE_SELECT_LIST_BY_COURSE_LOCAL_SUCCESS,
  GetGradeSelectListByCourseLocalAction,
  ResetGradeSelectListByCourseLLocalAction,
  RESET_GRADE_SELECT_LIST_BY_COURSE_LOCAL,
} from "./actionTypes";
import { PaginateQuery, Paginated, SelectListDto } from "../../models";
import {
  CreateGradeRequest,
  GradeDto,
  UpdateGradeRequest,
} from "../../interfaces/grade";

//#region Get Grade Select List by Course

export const getGradeSelectListByCourse = (
  courseId: string
): GetGradeSelectListByCourseAction => {
  return {
    type: GET_GRADE_SELECT_LIST_BY_COURSE,
    payload: { courseId },
  };
};

export const getGradeSelectListByCourseSuccess = (
  response: SelectListDto[]
): GetGradeSelectListByCourseSuccessAction => {
  return {
    type: GET_GRADE_SELECT_LIST_BY_COURSE_SUCCESS,
    payload: response,
  };
};

export const getGradeSelectListByCourseError = (
  error: any
): GetGradeSelectListByCourseErrorAction => {
  return {
    type: GET_GRADE_SELECT_LIST_BY_COURSE_ERROR,
    payload: error,
  };
};

//#endregion

//#region Get Grades Detailed List by Course

export const getGradesDetailByCourse = (
  courseId: string
): GetGradesDetailByCourseAction => {
  return {
    type: GET_GRADES_DETAIL_BY_COURSE,
    payload: { courseId },
  };
};

export const getGradesDetailByCourseSuccess = (
  response: SelectListDto[]
): GetGradesDetailByCourseSuccessAction => {
  return {
    type: GET_GRADES_DETAIL_BY_COURSE_SUCCESS,
    payload: response,
  };
};

export const getGradesDetailByCourseError = (
  error: any
): GetGradesDetailByCourseErrorAction => {
  return {
    type: GET_GRADES_DETAIL_BY_COURSE_ERROR,
    payload: error,
  };
};

//#endregion

//#region Get Grades

export const getGrades = (
  request: PaginateQuery,
  history: History
): GetGradesAction => {
  return {
    type: GET_GRADES,
    payload: { request, history },
  };
};

export const getGradesSuccess = (
  response: Paginated<GradeDto>
): GetGradesSuccessAction => {
  return {
    type: GET_GRADES_SUCCESS,
    payload: response,
  };
};

export const getGradesError = (error: any): GetGradesErrorAction => {
  return {
    type: GET_GRADES_ERROR,
    payload: error,
  };
};

//#endregion

//#region Get Grade

export const getGrade = (id: string, history: History): GetGradeAction => {
  return {
    type: GET_GRADE,
    payload: { id, history },
  };
};

export const getGradeSuccess = (response: GradeDto): GetGradeSuccessAction => {
  return {
    type: GET_GRADE_SUCCESS,
    payload: response,
  };
};

export const getGradeError = (error: any): GetGradeErrorAction => {
  return {
    type: GET_GRADE_ERROR,
    payload: error,
  };
};

//#endregion

//#region Add Grade

export const addGrade = (
  request: CreateGradeRequest,
  history: History
): AddGradeAction => {
  return {
    type: ADD_GRADE,
    payload: { request, history },
  };
};

export const addGradeSuccess = (): AddGradeSuccessAction => {
  return {
    type: ADD_GRADE_SUCCESS,
    payload: null,
  };
};

export const addGradeError = (error: any): AddGradeErrorAction => {
  return {
    type: ADD_GRADE_ERROR,
    payload: error,
  };
};

//#endregion

//#region Update Grade

export const updateGrade = (
  id: string,
  request: UpdateGradeRequest,
  history: History
): UpdateGradeAction => {
  return {
    type: UPDATE_GRADE,
    payload: { id, request, history },
  };
};

export const updateGradeSuccess = (): UpdateGradeSuccessAction => {
  return {
    type: UPDATE_GRADE_SUCCESS,
    payload: null,
  };
};

export const updateGradeError = (error: any): UpdateGradeErrorAction => {
  return {
    type: UPDATE_GRADE_ERROR,
    payload: error,
  };
};

//#endregion

//#region Delete Grade

export const deleteGradeConsent = (id: string): DeleteGradeConsentAction => {
  return {
    type: DELETE_GRADE_CONSENT,
    payload: id,
  };
};

export const deleteGrade = (
  id: string,
  history: History
): DeleteGradeAction => {
  return {
    type: DELETE_GRADE,
    payload: { id, history },
  };
};

export const deleteGradeSuccess = (): DeleteGradeSuccessAction => {
  return {
    type: DELETE_GRADE_SUCCESS,
    payload: null,
  };
};

export const deleteGradeError = (error: any): DeleteGradeErrorAction => {
  return {
    type: DELETE_GRADE_ERROR,
    payload: error,
  };
};

//#endregion

//#region Get Grade Select List by Course

export const getGradeSelectListByCourseLocal = (
  courseId: string
): GetGradeSelectListByCourseLocalAction => {
  return {
    type: GET_GRADE_SELECT_LIST_BY_COURSE_LOCAL,
    payload: { courseId },
  };
};

export const getGradeSelectListByCourseLocalSuccess = (
  response: SelectListDto[]
): GetGradeSelectListByCourseLocalSuccessAction => {
  return {
    type: GET_GRADE_SELECT_LIST_BY_COURSE_LOCAL_SUCCESS,
    payload: response,
  };
};

export const getGradeSelectListByCourseLocalError = (
  error: any
): GetGradeSelectListByCourseErrorAction => {
  return {
    type: GET_GRADE_SELECT_LIST_BY_COURSE_LOCAL_ERROR,
    payload: error,
  };
};

export const resetGradeSelectListByCourseLocal =
  (): ResetGradeSelectListByCourseLLocalAction => {
    return {
      type: RESET_GRADE_SELECT_LIST_BY_COURSE_LOCAL,
      payload: {},
    };
  };

//#endregion
